{
  "es": {
    "title": "No se puede cargar el inventario",
    "missingPropertyId": "Falta el parámetro propertyId en la URL. El sistema embebido debe pasar el UUID de Rentmote devuelto por el workflow de sesión n8n.",
    "missingToken": "Falta el parámetro token en la URL. El sistema embebido debe pasar el token de sesión devuelto por el workflow de sesión n8n."
  },
  "en": {
    "title": "Cannot load inventory",
    "missingPropertyId": "Missing propertyId URL parameter. The embedding system must pass the Rentmote UUID returned by the n8n session workflow.",
    "missingToken": "Missing token URL parameter. The embedding system must pass the session token returned by the n8n session workflow."
  }
}
